var map = {
	"./Almanac.svg": 8896,
	"./Anchorage.svg": 5449,
	"./Area.svg": 6216,
	"./Close.svg": 8509,
	"./CulturalInformation.svg": 169,
	"./HarbourWithYachtFacilities.svg": 4734,
	"./Mooring.svg": 4032,
	"./OtherHarbour.svg": 6860,
	"./SearchIcon.svg": 360,
	"./UserAnchorage.svg": 8306,
	"./UserHarbourWithYachtFacilities.svg": 3663,
	"./UserMooring.svg": 5987,
	"./UserOtherHarbour.svg": 269,
	"./UserYachtMarina.svg": 789,
	"./YachtMarina.svg": 2610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7521;